/* eslint max-len: ["error", { "ignoreStrings": true }] */
import React from 'react'
import Facebook from '../assets/svg/facebook.svg'
import Instagram from '../assets/svg/instagram.svg'
import Linkedin from '../assets/svg/linkedin.svg'
import Logo from '../assets/svg/logo.svg'
import LogoAr from '../assets/svg/logo_AR.svg'
import LogoEn from '../assets/svg/logo_EN.svg'
import Twitter from '../assets/svg/twitter.svg'
import IPhoneLarge from '../assets/svg/iPhone-large.svg'
import IPhoneSmall from '../assets/svg/iPhone-small.svg'
import LoadingSpinnerIcon from '../assets/svg/loading.svg'
import SocialShareIcon from '../assets/svg/social-share.svg'
import KSAFlagIcon from '../assets/svg/KSA-flag.svg'
import CarCalculatorImage from '../assets/svg/auto-leasing-calculator.svg'
import Minus from '../assets/svg/minus.svg'
import Plus from '../assets/svg/plus.svg'
import Timeline from '../assets/svg/timeline.svg'
import Motorcycle from '../assets/svg/motorcycle.svg'
import LinkIcon from '../assets/svg/link.svg'
import BriefcaseIcon from '../assets/svg/briefcase.svg'
import PencilIcon from '../assets/svg/pencil.svg'
import StackIcon from '../assets/svg/stack.svg'
import DocumentIcon from '../assets/svg/document.svg'
import NationalIdIcon from '../assets/svg/national-id.svg'
import StatementsIcon from '../assets/svg/statements.svg'
import TransportIcon from '../assets/svg/transport.svg'
import RestartIcon from '../assets/svg/restart.svg'
import WhatsappIcon from '../assets/svg/whatsapp.svg'
import TelIcon from '../assets/svg/tel.svg'
import MailtoIcon from '../assets/svg/mailto.svg'
import LocationIcon from '../assets/svg/location.svg'
import CalculatorSuccessIcon from '../assets/svg/calculator-success.svg'
import InformationIcon from '../assets/svg/information.svg'
import MonthlyFeature from '../assets/svg/monthly-feature.svg'
import FiftyFiftyFeature from '../assets/svg/fifty-fifty-feature.svg'
import SignAndDriveFeature from '../assets/svg/sign-and-drive-feature.svg'
import SignAndDriveFeature1 from '../assets/svg/sign-and-drive-feature-1.svg'
import AppStoreIcon from '../assets/svg/download-appstore.svg'
import PlayStoreIcon from '../assets/svg/download-playstore.svg'
import CoinStack from '../assets/svg/coin-stack.svg'
import BlockIcon from '../assets/svg/block.svg'
import BuddyIcon from '../assets/svg/buddy.svg'
import TasksIcon from '../assets/svg/tasks.svg'
import TickIcon from '../assets/svg/tick.svg'
import FlexiFeature from '../assets/svg/flexi-feature.svg'
import TakhayerFeature from '../assets/svg/takhayer-feature.svg'
import TakhayerFeature1 from '../assets/svg/takhayer-feature-1.svg'
import ShieldIcon from '../assets/svg/shield.svg'
import PersonalFinanceRebus from '../assets/svg/personal-finance-rebus.svg'
import ClockIcon from '../assets/svg/clock.svg'
import ArrowDownIcon from '../assets/svg/arrow-down.svg'
import PersonalFinanceStandardFeature from '../assets/svg/personal-finance-standard-feature.svg'
import AppGalleryIcon from '../assets/svg/download-appgallery.svg'
import AppGalleryMobileIcon from '../assets/svg/download-appgallery-mobile.svg'
import AppStoreMobileIcon from '../assets/svg/download-appstore-mobile.svg'
import PlayStoreMobileIcon from '../assets/svg/download-playstore-mobile.svg'
import FinishFlagICon from '../assets/svg/finish-flag.svg'

// Icon shapes for passing SVG as child to SVGIcon
const ICON_SHAPES = {
  hamburger: (
    <path
      d="M24 0L24 3 0 3 0 0zM24 20L24 23 0 23 0 20zM24 10L24 13 0 13 0 10z"
      transform="translate(-16 -19) translate(16 15) translate(0 4)"
    />
  ),
  close: (
    <path
      d="M16.265 0.293L17.679 1.707 10.4 8.986 17.679 16.265 16.265 17.679 8.986 10.4 1.707 17.679 0.293 16.265 7.571 8.986 0.293 1.707 1.707 0.293 8.986 7.571z"
      transform="translate(-26 -114) translate(27 115)"
    />
  ),
}
export {
  ICON_SHAPES,
  LogoEn,
  LogoAr,
  Logo,
  Facebook,
  Twitter,
  Instagram,
  Linkedin,
  IPhoneLarge,
  IPhoneSmall,
  LoadingSpinnerIcon,
  SocialShareIcon,
  KSAFlagIcon,
  CarCalculatorImage,
  Minus,
  Plus,
  Timeline,
  Motorcycle,
  LinkIcon,
  BriefcaseIcon,
  PencilIcon,
  StackIcon,
  DocumentIcon,
  NationalIdIcon,
  StatementsIcon,
  TransportIcon,
  RestartIcon,
  WhatsappIcon,
  TelIcon,
  MailtoIcon,
  LocationIcon,
  CalculatorSuccessIcon,
  InformationIcon,
  MonthlyFeature,
  FiftyFiftyFeature,
  SignAndDriveFeature,
  SignAndDriveFeature1,
  AppStoreIcon,
  PlayStoreIcon,
  CoinStack,
  BlockIcon,
  BuddyIcon,
  TasksIcon,
  TickIcon,
  FlexiFeature,
  TakhayerFeature,
  TakhayerFeature1,
  ShieldIcon,
  PersonalFinanceRebus,
  ClockIcon,
  ArrowDownIcon,
  PersonalFinanceStandardFeature,
  AppGalleryIcon,
  AppGalleryMobileIcon,
  AppStoreMobileIcon,
  PlayStoreMobileIcon,
  FinishFlagICon,
}
